import { render, staticRenderFns } from "./hospitalCleaning.vue?vue&type=template&id=5356b4b1&scoped=true"
import script from "./hospitalCleaning.vue?vue&type=script&lang=js"
export * from "./hospitalCleaning.vue?vue&type=script&lang=js"
import style0 from "./hospitalCleaning.vue?vue&type=style&index=0&id=5356b4b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5356b4b1",
  null
  
)

export default component.exports